import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberHealthConditions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberHealthConditionsService } from 'services/memberHealthConditions';
 *
 * // create service instance and send/cancel request
 * const memberHealthConditionsService = new MemberHealthConditionsService();
 * const result = await memberHealthConditionsService.fetchData( '<user-id>' ); // fetch data
 * memberHealthConditionsService.cancel(); // cancel an active request
 */
export class MemberHealthConditionsService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract component data
            const visibility = get( response, 'body.component.visibility', {} );
            const actions = get( response, 'body.component.structure.actions', [] );
            const noDataView = get( response, 'body.component.structure.noDataView', [] );
            const checkData = get( response, 'body.component', {} );

            if( SERVICE_RESPONSE_STATUS.SUCCESS === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                    data: {
                        data: get( response, 'body.component.data.state.memberHealthConditions', [] ),
                        memberData: get( response, 'body.component.data.state', {} ),
                        action: actions,
                        visibility,
                        noDataView,
                        checkData
                    },
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: get( response, 'body.component', {} )
                };
            }
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // make given contact as default one
    async fetchAddEditForm( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
            
            const visibility = get( response, 'body.component.visibility', {}  );
            const healthConditions = get( response, 'body.component.data.state.memberHealthConditions', [] );
            const sections = getVisibleItems( get( response, 'body.component.structure.sections', {} ), visibility );
            const action = get( response, 'body.component.structure.actions', [] );
            const widgetConfig = get( response, 'body.component.structure.widgetConfig', {} );
            const finalprop = get( response, 'body.component.data.state',{} );
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    healthConditions,
                    sections,
                    action,
                    widgetConfig,
                    finalprop,
                    visibility
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make given contact as default one
    async saveEditHealthConditions( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                _status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                _data: {},
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
